
const HOST = process.env.REACT_APP_HOST || 'localhost';
const PORT = process.env.REACT_APP_PORT || 5000;
const PROTOCOL = (HOST !== "localhost" && HOST !== "127.0.0.1")
  ? `https`
  : `http`;

const PAGE_SIZE = 32;

const _getURL = () => {
  let _host = process.env.REACT_APP_HOST || 'localhost';
  let _port = process.env.REACT_APP_PORT || 5000;
  let _protocol = (_host !== "localhost" && _host !== "127.0.0.1")
    ? `https`
    : `http`;
  return `${_protocol}://${_host}:${_port}`;
};

export {
  HOST,
  PORT,
  PROTOCOL,
  PAGE_SIZE,
  _getURL,
}



// WEBPACK FOOTER //
// ./src/config.js